module.exports = __webpack_public_path__ + "img/cost.59a4cdcb.png";